import { Component, Inject, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DOCUMENT, Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import * as $ from 'jquery';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class HeaderComponent implements OnInit {
    mobile: boolean;
    location: any;
    styleContainer: any;
    public isCollapsed = false;
    solution_openfas = true;
    service_openfas = true;

    constructor(
        private router: Router,
        location: Location
    ) { }

    ngOnInit() {
        if (window.screen.width < 768) { // 768px portrait
            this.mobile = true;
        } else {
            this.mobile = false;
        }
        this.router.events
            .subscribe((event) => {
                if ( event instanceof NavigationEnd ) {
                    this.location = this.router.url;
                    if (this.location === '/') {
                        this.styleContainer = 'container-fluid';
                    } else {
                        this.styleContainer = 'container';
                    }
                }
            });
    }

    showSubmenu(submenu: string) {
        if (submenu == "solution-submenu") {
            if ($("#solution-fas-id").hasClass("fa-chevron-down")) {
                this.solution_openfas = false;
            } else if ($("#solution-fas-id").hasClass("fa-chevron-up")) {
                this.solution_openfas = true;
            }
            setTimeout(() => {
                $("#solution-submenu").addClass("show");
            }, 10);
        } else if (submenu == "service-submenu") {
            if ($("#service-fas-id").hasClass("fa-chevron-down")) {
                this.service_openfas = false;
            } else if ($("#service-fas-id").hasClass("fa-chevron-up")) {
                this.service_openfas = true;
            }
            setTimeout(() => {
                $("#service-submenu").addClass("show");
            }, 10);
        }
    }
}
